const filterBtns = document.querySelectorAll('.filter__item');
const groups = document.querySelectorAll('.group__item');

const showAllBtn = document.querySelector('.filter__btn-showAllBtn');
const groupFilterBtn = document.querySelector('.filter__btn-group');
const dayFilterBtn = document.querySelector('.filter__btn-day');

[...filterBtns].forEach((filterBtn) => {
    filterBtn.addEventListener('click', () => {
        const groupDay = filterBtn.getAttribute('day-filter')
        const allGroups = 'all'

        if (filterBtn.classList.contains('filter__item--selected')) {
            filterBtn.classList.remove('filter__item--selected');
            groups.forEach((group) => {
                if ( group.getAttribute('day-filter') === groupDay || filterBtn.getAttribute('data-filter') == allGroups) {
                    group.classList.remove('--show')
                } 
            });
        } else {
            if (filterBtn.getAttribute('data-filter') == allGroups) {
                if( !showAllBtn.classList.contains('filter__item--selected')) {
                    filterBtn.classList.add('filter__item--selected');
                    const filterBtns = document.querySelectorAll('.filter__item');
                    [...filterBtns].forEach((filterBtn) => {
                        if (filterBtn.getAttribute('group-filter') != allGroups) {
                            filterBtn.classList.remove('filter__item--selected');
                        }    
                    });
                    filterBtn.classList.add('filter__item--selected');
                    groups.forEach((group) => {
                        group.classList.add('--show')
                    });
                } 
            } else {
                if (showAllBtn.classList.contains('filter__item--selected')) {
                    showAllBtn.classList.remove('filter__item--selected')
                    filterBtn.classList.add('filter__item--selected')
                    groups.forEach((group) => {
                        group.classList.remove('--show')
                        if ( group.getAttribute('day-filter') === groupDay) {
                            group.classList.add('--show')
                        }
                    });    
                } else {
                    filterBtn.classList.add('filter__item--selected')
                    groups.forEach((group) => {
                        if ( group.getAttribute('day-filter') === groupDay) {
                            group.classList.add('--show')
                        }
                    });    
                }   
            }
        }
    });
});
